import axios from "axios";
import {saveSingleEndPointLogAPI} from "../api/singleEndPointLog"
import {AppAdtopiaUPID,AppEnv} from "../Constants/EnvConstants"
require("dotenv").config();
require("dotenv").config();
const adtopia_api_url = process.env.REACT_APP_ADTOPIA_TRACKING_API;
const adtopia_api_token = process.env.REACT_APP_ADTOPIA_TOKEN;
export const AdtopiaApi = axios.create({
  baseURL: adtopia_api_url,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer " + adtopia_api_token,
  },
});
/**
 * Apply Interceptor
 */
const applyInterceptors = (instance) => {
  instance.interceptors.response.use(
    async (response) => {
      try {
        let requestData = {};

        try {
          requestData = JSON.parse(response.config?.data || "{}");
        } catch {
          requestData = response.config?.data || {};
        }

        if (
          !response.config?.baseURL?.startsWith("https://chat.googleapis")
        ) {
          await saveSingleEndPointLogAPI({
            ProjectCode: AppAdtopiaUPID,
            Environment: AppEnv,
            request: requestData,
            url: response.config?.url,
            baseURL: response.config?.baseURL,
            response: response.data,
            statusCode: response.status,
          });
        }
      } catch (logError) {
        console.error("Failed to save API log:", logError?.message);
      }
      return response;
    },
    async (error) => {
      try {
        let requestData = {};
        try {
          requestData = JSON.parse(error.config?.data || "{}");
        } catch {
          requestData = error.config?.data || {};
        }
        if (
          !error.config?.baseURL?.startsWith("https://chat.googleapis")
        ) {
          await saveSingleEndPointLogAPI({
            ProjectCode: AppAdtopiaUPID,
            Environment: AppEnv,
            request: requestData,
            url: error.config?.url,
            baseURL: error.config?.baseURL,
            response: {
              errorMessage: error.message,
              statusCode: error.response?.status,
              data: error.response?.data,
              errorCode: error.code,
            },
          });
        }
      } catch (logError) {
        console.error("Failed to save API error log:", logError?.message);
      }
      return Promise.reject(error);
    }
  );
};
/**
 * Apply interceptor to AdtopiaApi
 */
applyInterceptors(AdtopiaApi);
